<template>
  <div class="banner">
    <div class="bannerImg">
      <img :src="require(`@/assets/image/banner${type}.png`)" />
    </div>
    <div class="wechatImg">
      <img :src="require(`@/assets/image/wechat${type}.png`)" />
    </div>
    <div class="btn" v-clipboard:copy="number" v-clipboard:success="onCopy" v-clipboard:error="onError">复制微信</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: null,
      number: 'qudaowuyou-2020'
    }
  },
  created(){
    this.type = this.$route.query.type
  },
  methods: {
    onCopy () {
      this.$toast("复制成功")
    },
    // 复制失败时的回调函数
    onError () {
      this.$toast("抱歉，复制失败")
    }
  }
};
</script>
<style lang="scss" scoped>
.banner {
  text-align: center;
  padding-top:2.8rem;
  img{
    width: 100%;
  }
  .bannerImg{
    width: 9.146667rem;
    margin: 0 auto;
  }
  .wechatImg{
    width: 6.853333rem;
    margin: 1.6rem auto 0.8rem;
  }
  .btn{
    width: 8.08rem;
    height: 1.173333rem;
    line-height: 1.173333rem;
    background: #F3474A;
    opacity: 1;
    border-radius: 8px;
    margin: 0 auto;
    font-size: 0.426667rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 1;
  }
}
</style>